import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["border", "div", "button", "field"]

    connect() {
        this.updateUI()
    }

    toggle() {
        const hidden_field_value = this.fieldTarget.value

        if (hidden_field_value === "true") {
            this.fieldTarget.value = "false"
        } else {
            this.fieldTarget.value = "true"
        }

        this.updateUI()
    }

    updateUI() {
        const isChecked = this.fieldTarget.value === "true"

        this.buttonTarget.setAttribute("aria-checked", isChecked)

        this.buttonTarget.classList.toggle("bg-gray-200", !isChecked)
        this.buttonTarget.classList.toggle("bg-primary-box", isChecked)
        this.buttonTarget.querySelector("span").classList.toggle("translate-x-0", !isChecked)
        this.buttonTarget.querySelector("span").classList.toggle("translate-x-5", isChecked)

        this.divTarget.classList.toggle("hidden", isChecked)

        this.borderTarget.classList.toggle("border-dotted", !isChecked)
        this.borderTarget.classList.toggle("border-gray-200", !isChecked)
        this.borderTarget.classList.toggle("border-solid", isChecked)
        this.borderTarget.classList.toggle("border-primary", isChecked)
    }
}